function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "Edit",
  transform: "translate(0.000000, 1.000000)",
  stroke: "#979797"
}, React.createElement("g", {
  id: "Group-10",
  transform: "translate(1.000000, 0.000000)"
}, React.createElement("g", {
  id: "new"
}, React.createElement("path", {
  d: "M13,8.77777778 L13,14.2222222 C13,14.651777 12.6362313,15 12.1875,15 L0.8125,15 C0.363768641,15 0,14.651777 0,14.2222222 L0,1.77777778 C0,1.34822297 0.363768641,1 0.8125,1 L8.125,1",
  id: "Path"
}), React.createElement("path", {
  d: "M14.104864,0.417031571 L14.5829684,0.895136007 C15.1390105,1.4511781 15.1390105,2.35270047 14.5829684,2.90874256 L7.49171099,10 L5,10 L5,7.50828901 L12.0912574,0.417031571 C12.6472995,-0.139010524 13.5488219,-0.139010524 14.104864,0.417031571 Z M11.2292775,1.27901154 L13.7209885,3.77072253 L11.2292775,1.27901154 Z",
  id: "Shape"
})))));

var SvgSquareEdit = function SvgSquareEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSquareEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/square_edit.4f48d86e.svg";
export { ForwardRef as ReactComponent };